/** @jsx jsx */
import { Fragment, ReactNode } from 'react';
import { jsx, css } from '@emotion/react';
import { useTabPanel } from '@atlaskit/tabs';
import Stack from '@atlaskit/primitives/stack';
import { token } from '@atlaskit/tokens';

const containerStyles = css({
  // Create space between TabList and TabPanel so it matches the top margin for non-tabbed content
  marginTop: token('space.400', '32px'),
});

interface TabPanelProps {
  children: ReactNode;
}

const TabPanel = ({ children }: TabPanelProps) => {
  const panelAttributes = useTabPanel();
  return (
    <div css={containerStyles}>
      <Stack space="space.200" {...panelAttributes}>
        <Fragment>{children}</Fragment>
      </Stack>
    </div>
  );
};

export default TabPanel;
